class CheckpointRenderer
{
    public static render()
    {

    }
}

export default CheckpointRenderer;